import { auth } from '../../../../../utils/auth';
import { getIframely } from '../../../../../utils/getIframely';
import { ArticleFromUrl } from '../Sections/Section/types';

export const getArticleInfoFromUrl = async (articleLink: any) => {
  const jwt = await auth.getJwt();
  const myRequest = new Request(`${config.API_URL}/metaFromExternalArticle`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify({
      externalArticleUrl: articleLink,
    }),
  });
  let result;
  try {
    const response = await fetch(myRequest);
    result = await response.text();
  } catch (e) {
    console.error(`Error requesting ${articleLink}`);
    throw e;
  }
  const ogKeys = ['title', 'image', 'description'];
  const regExp = new RegExp(`^og:(${ogKeys.join('|')})$`, 'g');
  const parser = new DOMParser();
  const doc = parser.parseFromString(result, 'text/html');
  const metas = doc.querySelectorAll('meta');
  const articleInfo = Array.from(metas).reduce(
    (acc, meta: HTMLMetaElement) => {
      const property = meta.attributes.getNamedItem('property');
      const matched = property ? property.value.match(regExp) : null;
      if (!matched || !property) {
        return acc;
      }
      return {
        ...acc,
        [property.value.replace('og:', '')]: meta.attributes.getNamedItem(
          'content',
        )
          ? meta.attributes.getNamedItem('content')?.value
          : null,
      };
    },
    {
      title: null,
      url: null,
      image: null,
      description: null,
    },
  );
  const articleInfoForBlock: ArticleFromUrl = {
    title: articleInfo.title,
    url: articleLink,
    content: articleInfo.description,
    media: null,
  };
  if (articleInfo.image) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const iframely = await getIframely(articleInfo.image!);
    if (iframely) {
      // eslint-disable-next-line immutable/no-mutation
      articleInfoForBlock.media = {
        iframely,
      };
    }
  }
  return articleInfoForBlock;
};
